import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import PostsReducer from './reducers/PostsReducer';
import thunk from 'redux-thunk';
import { AuthReducer } from './reducers/AuthReducer';
import todoReducers from './reducers/Reducers';
import DepositorsReducer from './reducers/DepositorsReducer';
import PartnersReducer from './reducers/PartnersReducer';
import DepositsReducer from './reducers/DepositsReducer';
import DepositInterestReducer from './reducers/DepositInterestReducer';
import InvestmentReducer from './reducers/InvestmentReducer';
import CompaniesReducer from './reducers/CompaniesReducer';
import KycReducer from './reducers/KycReducer';
import BranchesReducer from './reducers/BranchesReducer';
import UsersReducer from './reducers/UsersReducer';
import CompanyUsersReducer from './reducers/CompanyUsersReducer';
import DashboardReducer from './reducers/DashboardReducer';
import LoansReducer from './reducers/LoansReducer';
import CustomerReducer from './reducers/CustomerReducer';
import ExpensesReducer from './reducers/ExpensesReducer';
import CompanyBalanceReducer from './reducers/CompanyBalanceReducer';
import BranchBalanceReducer from './reducers/BranchBalanceReducer';
import menuReducer from './menu/menuReducer';
import CollectionsReducer from './reducers/CollectionsReducer';


//import { reducer as reduxFormReducer } from 'redux-form';
const middleware = applyMiddleware(thunk);

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
    posts: PostsReducer,
    auth: AuthReducer,
    todoReducers,
    depositors: DepositorsReducer,
    partners: PartnersReducer,
    deposits: DepositsReducer,
    depositInterest: DepositInterestReducer,
    investments: InvestmentReducer,
    companies: CompaniesReducer,
    kyc: KycReducer,
    branches: BranchesReducer,
    users: UsersReducer,
    companyUsers: CompanyUsersReducer,
    dashboard: DashboardReducer,
    loans: LoansReducer,
    customers: CustomerReducer,
    expenses: ExpensesReducer,
    companyBalance: CompanyBalanceReducer,
    branchBalance: BranchBalanceReducer,
    collections: CollectionsReducer,
    menu: menuReducer,
    //form: reduxFormReducer,
});

export const store = createStore(reducers, composeEnhancers(middleware));
